var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSuccess,
      expression: "isSuccess"
    }],
    staticClass: "successWrap"
  }, [_c("div", {
    staticClass: "box"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Success.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "title"
  }, [_vm._v("Success!")]), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("YQHBS")))]), _c("span", {
    staticClass: "text1"
  }, [_vm._v(_vm._s(_vm.$t("TYFYP")))]), _c("div", {
    staticClass: "btn1",
    on: {
      click: _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t("Confirm")))])])]), _c("TitleBar"), _c("div", {
    staticClass: "img-con-top"
  }, [_c("img", {
    attrs: {
      src: "https://tpage.soimt.com/APP/SNS/P14.png",
      alt: ""
    }
  }), _c("div", {
    staticClass: "text-con"
  }, [_c("h4", [_vm._v(_vm._s(_vm.title))]), _c("span", {
    staticClass: "bottom"
  }, [_vm._v(_vm._s(_vm.content))])])]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.toAnswer
    }
  }, [_vm._v("Start")]), _vm.isShow ? _c("div", {
    staticClass: "wrap"
  }, [_c("div", {
    staticClass: "question"
  }, [_c("div", {
    staticClass: "close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.hidePop.apply(null, arguments);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Close.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "num"
  }, [_c("span", [_vm._v("Q" + _vm._s(_vm.num))]), _vm.questions[_vm.num - 1].type === 1 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [Single Choice]")]) : _vm._e(), _vm.questions[_vm.num - 1].type === 2 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [Multiple Choice]")]) : _vm._e(), _vm.questions[_vm.num - 1].type === 3 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [" + _vm._s(_vm.$t("Completion")) + "]")]) : _vm._e()]), _c("div", {
    staticClass: "progress"
  }, [_c("div", {
    staticClass: "top",
    style: "width:" + _vm.lineWidth + "px;"
  }), _c("div", {
    staticClass: "bottom"
  })]), _c("h4", [_vm._v(_vm._s(_vm.questions[_vm.num - 1].title))]), _vm.questions[_vm.num - 1].type === 1 && _vm.isShowOptions ? _c("div", {
    staticClass: "item"
  }, _vm._l(_vm.options, function (item, index) {
    return _c("span", {
      key: index,
      class: [{
        active: item.selected
      }],
      on: {
        click: function click($event) {
          return _vm.onSelect(index);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0) : _vm._e(), _vm.questions[_vm.num - 1].type === 2 && _vm.isShowOptions ? _c("div", {
    staticClass: "item"
  }, _vm._l(_vm.options, function (item, index) {
    return _c("span", {
      key: index,
      class: [{
        active: item.selected
      }],
      on: {
        click: function click($event) {
          return _vm.onMultipleSelect(index);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0) : _vm._e(), _vm.questions[_vm.num - 1].type === 3 ? _c("van-field", {
    attrs: {
      autosize: "",
      type: "textarea",
      placeholder: "Say something…",
      "show-word-limit": ""
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }) : _vm._e()], 1), _c("div", {
    staticClass: "btn-con"
  }, [_c("div", {
    class: ["last", {
      active: !_vm.isStart
    }],
    on: {
      click: _vm.last
    }
  }, [_vm._v(_vm._s(_vm.$t("Last")))]), !_vm.isEnd ? _c("div", {
    staticClass: "last active",
    on: {
      click: _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("Next")))]) : _c("div", {
    staticClass: "last",
    on: {
      click: function click($event) {
        return _vm.next("submit");
      }
    }
  }, [_vm._v("end")])])]) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };